// extracted by mini-css-extract-plugin
export default {"bookRideCard__step":"styles_bookRideCard__step__Yk0d6","bookRideCard__description":"styles_bookRideCard__description__09l9T"};